/** Configuration constants for Scenario API integration */
export const ScenarioConfig = {
  /** Job polling configuration */
  polling: {
    /** Maximum polling attempts for standard jobs (10 minutes at 5s intervals) */
    maxAttempts: 120,
    /** Polling interval in milliseconds */
    intervalMs: 5000,
    /** Maximum polling attempts for 3D jobs (15 minutes at 5s intervals) */
    max3DAttempts: 180,
  },

  /** Rate limiting configuration */
  rateLimit: {
    /** Minimum interval between same endpoint calls in milliseconds */
    minIntervalMs: 100,
  },

  /** Retry configuration for failed API calls */
  retry: {
    /** Maximum number of retries for 500 errors */
    maxRetries: 3,
    /** Base delay for exponential backoff in milliseconds */
    backoffBaseMs: 1000,
  },

  /** Known texture model IDs from Scenario's web interface */
  models: {
    textureModelIds: [
      'model_A2fozwiNdZh2N6fYPw8gyXUo',
      'model_jM6aNXDGR2DyqujYRisjDa6r',
      'model_6yBBAmCv1RFJFkq6aKikWpaL',
      'model_tmVVbrJZRNxr3aPj96jrUWrm',
      'model_F4Wmu5GoDKhSmLNtNotipqTn',
      'model_j54q3WGgRiR5qGtadYDfwePQ',
      'model_jAsNQL6sZAoXFrtK1v37DmKD',
      'model_ySKF8HKAzhQneW5ZQF6w3DDk',
      'model_82CfzMGYGTiwMyDTtbAA7vrP',
      'model_zdWRX2RyZVBQXJyjeXyBKSgP',
      'model_y9RATUheDpFyXMnbKSXoEMEi',
      'model_so5cF1MMp9uSWYCoUtX6gr48',
      'model_4V3MQcRgcqVp8Ztp482mDoCZ',
      'model_RqajTGgg77k9EXPQzR5deKf2',
      'model_iGLNAoe5QH1Q4UUtLXVF86Tb',
      'model_mX1K93FXCdPP7xcFesCzagfY',
      'model_WhNrwLcgY7zix2AMLcL9GLFs',
      'model_LAuryPHwdozaDpc3vjfnHYmk',
      'model_ETnAtuDbPkBMimRwMjnf684J',
      'model_x3PYyApBke7RzTz2TRCRwtLW',
      'model_XDLgaFbVaxvzrqKRKf51swtN',
      'model_drMi7ZtRssBES5vQMeNjp6Rb',
      'model_xzdACQKwbz8PkeeE59GzTA5n',
      'model_AMjrkyouPaqbA1k3Kpiwm8uf',
    ],
  },

  /** Default parameters for various generation types */
  defaults: {
    skybox: {
      numOutputs: 1,
      numInferenceSteps: 30,
      geometryEnforcement: 50,
    },
    texture: {
      numSamples: 1,
      numInferenceSteps: 30,
      guidance: 7.5,
      width: 512,
      height: 512,
      tiling: true,
      seamless: true,
    },
    image: {
      numSamples: 1,
      numInferenceSteps: 30,
      guidance: 7.5,
      width: 512,
      height: 512,
    },
    textureConversion: {
      raised: 0.35,
      shiny: 0.6,
      polished: 0.66,
      angular: 0.5,
      invert: false,
    },
    img2img: {
      influence: 50,
    },
    skyboxUpscale: {
      scalingFactor: 2,
    },
    threeD: {
      paint: true,
      steps: 30,
      guidanceScale: 5,
      targetFaceNum: 10000,
    },
  },
} as const;

